import useGetCurriculumCountryCodeForURL, { useGetInCurriculumV2 } from '~/curriculum/hooks/useGetCurriculumCountryCode'
import ROUTES from '~/shared/constants/routes.const'

export default function useGetGradeOverviewPageRoute({
  grade,
  isOnboarding,
  specificCountryCode,
  topicOrder,
  isV2,
}: {
  grade: string | number
  isOnboarding?: boolean
  specificCountryCode?: string
  topicOrder?: number
  isV2?: ConstrainBoolean
}): string {
  const countryCode = useGetCurriculumCountryCodeForURL(specificCountryCode)
  const isCurriculumV2User = useGetInCurriculumV2()
  const isCurriculumV2 = isV2 ?? isCurriculumV2User
  const topicSegment = topicOrder ? `/${topicOrder}` : ''
  return isOnboarding
    ? `${ROUTES.ONBOARDING}${isCurriculumV2 ? '/v2' : ''}/${countryCode}/${grade}${topicSegment}`
    : `${ROUTES.CURRICULUM}${isCurriculumV2 ? '/v2' : ''}/${countryCode}/${grade}${topicSegment}`
}
